import React from "react";

// Admin Imports
import Dashboard from "views/seo/dashboard";
import Sites from "views/seo/sites";
import SiteDetail from "views/seo/sites/SiteDetail";
import Links from "views/seo/links";
import Donors from "views/seo/donors";
import Tasks from "views/seo/tasks";
import TaskDetail from "views/seo/tasks/TaskDetail";
import Todo from "views/seo/todo";
import SeoPositions from "views/seo/positions";
import SitePositions from "views/seo/positions/SitePositions";
import Reports from "views/seo/reports";
import SiteReport from "views/seo/reports/SiteReport";

// Auth Imports
import SignIn from "views/auth/SignIn";
import User from "views/auth/User";
import LoginLogs from "views/auth/LoginLogs";

// Icon Imports
import {
  MdDashboard,
  MdLanguage,
  MdLink,
  MdAssignment,
  MdCheckCircle,
  MdLock,
  MdSecurity,
  MdTrendingUp,
  MdAssessment,
} from "react-icons/md";

const routes = [
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
    showInMenu: false,
  },
  {
    name: "User",
    layout: "/auth",
    path: "user",
    icon: <MdLock className="h-6 w-6" />,
    component: <User />,
    showInMenu: false,
  },
  {
    name: "Журнал авторизаций",
    layout: "/auth",
    path: "login-logs",
    icon: <MdSecurity className="h-6 w-6" />,
    component: <LoginLogs />,
    showInMenu: false,
  },
  {
    name: "SEO Dashboard",
    layout: "/seo",
    path: "dashboard",
    icon: <MdDashboard className="h-6 w-6" />,
    component: <Dashboard />,
    showInMenu: true,
  },
  {
    name: "Список дел",
    layout: "/seo",
    path: "todo",
    icon: <MdCheckCircle className="h-6 w-6" />,
    component: <Todo />,
    showInMenu: true,
  },
  {
    name: "SEO Сайты",
    layout: "/seo",
    path: "sites",
    icon: <MdLanguage className="h-6 w-6" />,
    component: <Sites />,
    showInMenu: true,
  },
  {
    name: "Детали сайта",
    layout: "/seo",
    path: "sites/:id",
    icon: <MdLanguage className="h-6 w-6" />,
    component: <SiteDetail />,
    showInMenu: false,
  },
  {
    name: "SEO Ссылки",
    layout: "/seo",
    path: "links",
    icon: <MdLink className="h-6 w-6" />,
    component: <Links />,
    showInMenu: true,
  },
  {
    name: "SEO Доноры",
    layout: "/seo",
    path: "donors",
    icon: <MdLink className="h-6 w-6" />,
    component: <Donors />,
    showInMenu: false,
  },
  {
    name: "SEO Задачи",
    layout: "/seo",
    path: "tasks",
    icon: <MdAssignment className="h-6 w-6" />,
    component: <Tasks />,
    showInMenu: true,
  },
  {
    name: "Детали задачи",
    layout: "/seo",
    path: "tasks/:id",
    icon: <MdAssignment className="h-6 w-6" />,
    component: <TaskDetail />,
    showInMenu: false,
  },
  {
    name: "SEO Позиции",
    layout: "/seo",
    path: "positions",
    icon: <MdTrendingUp className="h-6 w-6" />,
    component: <SeoPositions />,
    showInMenu: true,
  },
  {
    name: "Позиции сайта",
    layout: "/seo",
    path: "positions/:siteId",
    icon: <MdTrendingUp className="h-6 w-6" />,
    component: <SitePositions />,
    showInMenu: false,
  },
  {
    name: "SEO Отчеты",
    layout: "/seo",
    path: "reports",
    icon: <MdAssessment className="h-6 w-6" />,
    component: <Reports />,
    showInMenu: true,
    adminOnly: true,
  },
  {
    name: "Отчет по сайту",
    layout: "/seo",
    path: "reports/:siteId",
    icon: <MdAssessment className="h-6 w-6" />,
    component: <SiteReport />,
    showInMenu: false,
  },
  
];
export default routes;
